/** @jsx jsx */
import { jsx } from '@emotion/core';
import { ReactElement, useState } from 'react';

import Timeout from 'app/developer-v3/components/Timeout';
import OutsideClickable from 'app/developer-v3/components/OutsideClickable';

type Props = {
  /** Children function that accepts isConfirming and onClick */
  children: (options: {
    isConfirming: boolean;
    onClick: () => void;
  }) => ReactElement;
  /** True to start confirming without user interaction */
  isConfirming?: boolean;
  /** Called when is accepted */
  onConfirm: () => void;
  /** false to never time out confirmation */
  shouldTimeOut?: boolean;
};

const confirmationTimeout = 3000;

const Confirmation = (props: Props) => {
  const [isConfirming, setIsConfirming] = useState(props.isConfirming || false);

  const onCancel = () => setIsConfirming(false);

  const inner = props.children({
    isConfirming,
    onClick: () => {
      setIsConfirming(!isConfirming);
      if (isConfirming) {
        props.onConfirm();
      }
    },
  });

  return isConfirming ? (
    <Timeout
      delay={confirmationTimeout}
      isWaiting={props.shouldTimeOut}
      onTimeout={onCancel}
    >
      <OutsideClickable onClickOutside={onCancel}>{inner}</OutsideClickable>
    </Timeout>
  ) : (
    inner
  );
};

export default Confirmation;
